<h3 mat-dialog-title>Stack Layer Color</h3>
<mat-dialog-content>
    <div class="aip-woptions-sidebar">
        <div *ngFor="let item of data.tableDef.fields">
            <div style="float: left;" [style]="{ 'width': item.validateColor ? '100%' : 'calc(100% - 15px)' }">
                <label matLab>{{ item.label || item.name }}</label>
                <input *ngIf="!item.validateColor"
                    matInput
                    readonly
                    type="text"
                    class="aip-input readonly"
                    [(ngModel)]="data.data[item.name]"
                />
                <ng-container *ngIf="item.validateColor">
                    <div class="color-container">
                        <input
                        matInput
                        readonly
                        type="text"
                        class="readonly aip-input color-input"
                        [(ngModel)]="data.data[item.name]"
                        />
                    <input
                        matInput
                        matTooltip="Select Color"
                        type="color"
                        id="select-stack-color"
                        class="editable aip-input color-select"
                        [class]="{ 'hidden': hideColorSelect }"
                        [(ngModel)]="data.data[item.name]"
                        (change)="onChange()"
                    />
                    </div>
                </ng-container>
                <ng-container *ngIf="item.validateColor">
                    <mat-error *ngIf="fieldMessage[item.name]">{{ fieldMessage[item.name] }}</mat-error>
                </ng-container>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [disabled]="!allowSave" mat-raised-button color="primary" class="aip-button" (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>OK</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>
